import * as R from 'ramda';
import * as Promise from 'bluebird';
import { fileSystem as desktopFileSystem } from './desktop.js';
import { fileSystem as mobileFileSystem } from './mobile.js';
import uuid from 'uuid/v1';
import async from 'async-es';

export const DROPBOX_APP_KEY = 'wqk9vkmycurjlvm';

export const fileSystem = () => {
  if (window && window.cordova) {
    if (window.cordova.platformId !== 'browser') {
      return mobileFileSystem();
    } else {
      return desktopFileSystem();
    }
  } else {
    throw new Error('Cordova not installed');
  }
};

export const isDesktop = () => window && window.cordova && window.cordova.platformId === 'browser';

export const isMobile = () => window && window.cordova && window.cordova.platformId !== 'browser';

export const getPlatform = () => (window && window.cordova ? window.cordova.platformId : '');

export const getPhotoUrl = imageDirectory => file => {
  if (cordova.platformId !== 'browser') {
    console.log('getPhotoUrl file', file);
    const normalizeUrl = window && window.Ionic ? window.Ionic.WebView.convertFileSrc : src => src;

    if (file.name !== '') {
      const fileName = file.name;
      console.log('getPhotoUrl filename', fileName);
      return normalizeUrl(imageDirectory + fileName);
    } else {
      return '';
    }
  } else {
    const path = window.require('path');
    const filePath = path.join(imageDirectory.localURL, file.name);

    return {
      name: file.name,
      url: fileSystem()
        .getImageUrl(filePath)
        .replace('cdvfile:', 'electronfile:'),
    };
  }
};

export const getPhoto = imageDirectory => photo => {
  if (cordova.platformId !== 'browser') {
    const filePathArray = photo.split('/');
    const normalizeUrl = window && window.Ionic ? window.Ionic.WebView.convertFileSrc : src => src;

    if (filePathArray.length > 0) {
      const fileName = filePathArray[filePathArray.length - 1];
      return normalizeUrl(imageDirectory + fileName);
    } else {
      return '';
    }
  } else {
    console.log(photo);
    return photo ? photo.replace('cdvfile:', 'electronfile:') : '';
  }
};

const sendDataMobile = ({ file, url }) =>
  new Promise((success, fail) => {
    const fileName = R.pipe(
      R.split('/'),
      R.last
    )(file);

    const sendDataSuccess = r => {
      console.log('Code = ' + r.responseCode);
      console.log('Response = ' + r.response);
      console.log('Sent = ' + r.bytesSent);
      success();
    };

    const sendDataFail = error => {
      // alert('An error has occurred: Code = ' + error.code);
      console.log('upload error source ' + error.source);
      console.log('upload error target ' + error.target);
      fail(error);
    };

    const options = new FileUploadOptions();
    options.fileKey = 'images';
    options.fileName = fileName;
    options.mimeType = 'image/png';
    options.chunkedMode = false;
    options.headers = {
      Connection: 'close',
    };

    const ft = new FileTransfer();
    ft.upload(file, encodeURI(url), sendDataSuccess, sendDataFail, options);
  });

const sendDataDesktop = ({ file, url }) =>
  new Promise((success, fail) => {
    console.log('file', file);
    const remote = window.require('electron').remote;
    const fs = remote.require('fs-extra');

    // const form = new FormData();
    fs.pathExists(file).then(exists => {
      if (exists) {
        const imageStream = fs.createReadStream(file);
        const parsedUrl = new URL(url);
        const host = parsedUrl.host;
        const path = parsedUrl.pathname + parsedUrl.search;

        console.log('submit', { host, path });

        const request = window.require('electron').remote.require('request');

        const formData = {
          images: imageStream,
        };

        request.post({ url, formData }, (err, _, body) => {
          if (err) {
            fail(err);
            return console.error('upload failed:', err);
          }
          console.log('Upload successful!  Server responded with:', body);
          success();
        });
      } else {
        console.log('File not exists');
        success();
      }
    });
  });

export const sendData = ({ file, url }) =>
  isDesktop() ? sendDataDesktop({ file, url }) : sendDataMobile({ file, url });

const mobileDownloadHandler = {
  downloadQueue: async.queue(({ file, url }, done) => {
    const fileTransfer = new FileTransfer();
    const uri = encodeURI(url);

    try {
      fileTransfer.download(
        uri,
        file,
        entry => {
          console.log('download complete: ' + entry.toURL());
          done();
        },
        error => {
          console.log('download error source ' + error.source);
          console.log('download error target ' + error.target);
          console.log('download error code' + error.code);
          done(error);
        },
        false,
        {}
      );
    } catch (err) {
      done(err);
    }
  }, 10),
};

const downloadDataMobile = ({ file, url }) =>
  new Promise((success, fail) => {
    const { getImageDirectory } = fileSystem();

    getImageDirectory().then(imageDirectoryReader => {
      const imageDirectoryUrl = imageDirectoryReader.nativeURL;
      const imageFilePath = `${imageDirectoryUrl}${file}`;

      mobileDownloadHandler.downloadQueue.push({ file: imageFilePath, url }, error => {
        if (error) {
          fail(error);
        } else {
          success();
        }
      });
    });
  });

const desktopDownloadHandler = {
  listenerCreated: false,
  callbackMap: {},
};

const downloadDataDesktop = ({ file, url }) =>
  new Promise((success, fail) => {
    console.log('file', file);
    const pathJoin = window.require('path');

    const { getImageDirectory } = fileSystem();
    const ipcRenderer = window.require('electron').ipcRenderer;

    if (!desktopDownloadHandler.listenerCreated) {
      desktopDownloadHandler.listenerCreated = true;
      ipcRenderer.on(`fileDownloaded`, (_, { fileUUID, error }) => {
        if (error) {
          console.log(`${fileUUID} -> file Downloaded Error`, error);
          desktopDownloadHandler.callbackMap[fileUUID] && desktopDownloadHandler.callbackMap[fileUUID].fail(error);
          delete desktopDownloadHandler.callbackMap[fileUUID];
        } else {
          console.log(`${fileUUID} -> file Downloaded`);
          desktopDownloadHandler.callbackMap[fileUUID] && desktopDownloadHandler.callbackMap[fileUUID].success();
          delete desktopDownloadHandler.callbackMap[fileUUID];
        }
      });
    }

    getImageDirectory().then(imageDirectoryReader => {
      const imageDirectoryUrl = imageDirectoryReader.localURL;
      const imageFilePath = pathJoin.join(imageDirectoryUrl, file);

      const parsedUrl = new URL(url);
      const host = parsedUrl.host;
      const path = parsedUrl.pathname + parsedUrl.search;

      console.log('downloading', { host, path, imageFilePath });

      const fileUUID = `file_${uuid()}_${file}`;
      desktopDownloadHandler.callbackMap[fileUUID] = { success, fail };
      ipcRenderer.send('getFile', { host, path, imageFilePath, fileUUID });
    });
  });

export const downloadData = ({ file, url }) =>
  isDesktop() ? downloadDataDesktop({ file, url }) : downloadDataMobile({ file, url });

export const downloadZipData = ({ file, url }) =>
  new Promise(success => {
    const { unzipFile } = fileSystem();

    if (isDesktop()) {
      downloadDataDesktop({ file, url })
        .then(() => unzipFile(file))
        .then(success)
        .catch(error => console.log(error) || success());
    } else {
      downloadDataMobile({ file, url })
        .then(() => unzipFile(file))
        .then(success)
        .catch(error => console.log(error) || success());
    }
  });
